module.exports = "pegasus/assets/blocks/image-1-theme5.png";